import angular from 'angular';
import uiRouter from 'angular-ui-router';

import adminChangePasswordComponent from './admin-change-password-component';

const adminChangePassword = angular.module('adminChangePassword', [uiRouter]);
adminChangePassword.component('adminChangePassword', adminChangePasswordComponent);

export default adminChangePassword.name;
